import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import Snackbar from '@material-ui/core/Snackbar'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import { selectSnack } from '../../selectors'
import actions from '../../actions'

class DialogContainer extends React.PureComponent {
  handleClose = (snack) => () => {
    this.props.update({ ...snack, open: false })
    setTimeout(() => this.props.remove(snack.id), 500)
  }

  renderSnack = (snack) => (
    <Snackbar
      key={snack.id}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={snack.open}
      autoHideDuration={snack.autoHideDuration || 6000}
      onClose={this.handleClose(snack)}
      message={snack.message}
      action={[
        <IconButton key="close" aria-label="Close" color="inherit" onClick={this.handleClose(snack)}>
          <CloseIcon />
        </IconButton>,
      ]}
    />
  )

  render() {
    return this.props.snacks.map(this.renderSnack)
  }
}

const mapStateToProps = selectSnack
const mapDispatchToProps = actions.snack

const enhance = compose(connect(mapStateToProps, mapDispatchToProps))

export default enhance(DialogContainer)
